module.exports = {"meta":{"start":"Kampaň začala"}};